import * as R from 'ramda';
function _addClassEl(el, className) {
    el.classList.add(className);
}
function _removeClassEl(el, className) {
    el.classList.remove(className);
}
function _setStyleEl(el, property, value) {
    el.style.setProperty(property, value);
}
function _addClass(vm, className) {
    vm.$set(vm.classes_, className, true);
}
function _removeClass(vm, className) {
    vm.$set(vm.classes_, className, false);
}
function _setStyle(vm, property, value) {
    vm.$set(vm.styles_, property, value);
}
function _addEvent(el, event, handler) {
    el.addEventListener(event, handler, false);
}
function _removeEvent(el, event, handler) {
    el.removeEventListener(event, handler, false);
}
function _hasClass(el, className) {
    return el.classList.contains(className);
}
function _getAttribute(el, attributeName) {
    return el.getAttribute(attributeName);
}
function _setAttribute(el, attributeName, attributeValue) {
    return el.setAttribute(attributeName, attributeValue);
}
function _removeAttribute(el, attributeName) {
    return el.removeAttribute(attributeName);
}
export function addBodyClass(className) {
    document.body.classList.add(className);
}
export function removeBodyClass(className) {
    document.body.classList.remove(className);
}
// Class manipuation
export const addClass = R.curry(_addClass);
export const removeClass = R.curry(_removeClass);
export const hasClass = R.curry(_hasClass);
export const addClassEl = R.curry(_addClassEl);
export const removeClassEl = R.curry(_removeClassEl);
export const setStyle = R.curry(_setStyle);
export const setStyleEl = R.curry(_setStyleEl);
// Event manipulation
export const addEvent = R.curry(_addEvent);
export const removeEvent = R.curry(_removeEvent);
// Attribute manipulation
export const getAttribute = R.curry(_getAttribute);
export const setAttribute = R.curry(_setAttribute);
export const removeAttribute = R.curry(_removeAttribute);
//# sourceMappingURL=dom.js.map